import { getFullUrl } from 'hubspot-url-utils';
import { useDetailsPageContext } from '../../context/DetailsPageContext';

// @ts-expect-error untyped dependency
import IFrame from 'ui-addon-iframeable/host/IFrame';
import { jsx as _jsx } from "react/jsx-runtime";
export function appendSpecifiedScopes(oauthQueryParams, specifiedScopes) {
  if (!specifiedScopes) {
    return oauthQueryParams;
  }
  const hasLeadingQuestionMark = oauthQueryParams.startsWith('?');
  const queryString = hasLeadingQuestionMark ? oauthQueryParams.slice(1) : oauthQueryParams;
  const params = new URLSearchParams(queryString);
  const existingScope = params.get('scope');
  const existingScopeList = existingScope ? existingScope.split(' ') : [];
  const newScopeList = specifiedScopes.split(' ');
  const mergedScopes = [...new Set([...existingScopeList, ...newScopeList])];
  params.set('scope', mergedScopes.join(' '));
  return `?${params.toString()}`;
}
export function HubSpotOAuthStep({
  oauthQueryParams,
  portalId,
  onOAuthSuccess,
  codeChallenge,
  codeChallengeMethod,
  optionalScopes,
  specifiedScopes
}) {
  const {
    trackInteraction
  } = useDetailsPageContext();
  const pkceParams = codeChallenge && codeChallengeMethod ? `&${new URLSearchParams({
    code_challenge: codeChallenge,
    code_challenge_method: codeChallengeMethod
  }).toString()}` : '';
  const optionalScopeParam = optionalScopes ? `&${new URLSearchParams({
    optional_scope: optionalScopes
  }).toString()}` : '';
  const oauthQueryParamsWithSpecifiedScopes = appendSpecifiedScopes(oauthQueryParams, specifiedScopes);
  return /*#__PURE__*/_jsx(IFrame, {
    src: `${getFullUrl('app')}/oauth/${portalId}/embedded/authorize${oauthQueryParamsWithSpecifiedScopes}${optionalScopeParam}${pkceParams}`,
    embeddedPassthruProps: {
      allowParentRedirect: true
    },
    onReady: () => {},
    onClose: () => {}
    // @ts-expect-error FIXME 2026-04-21 Issue found due to ui-addon-iframeable TS migration. See `#typesafe-ui-addon-iframeable` Slack channel for more details.
    ,
    onMessage: ({
      payload
    }) => {
      if (payload.type === 'OAUTH_SUCCESS') {
        onOAuthSuccess(payload.redirectUri);
        trackInteraction({
          action: 'complete hubspot oauth'
        });
      }
    },
    width: "100%",
    height: "100%",
    use: "default"
  });
}